import { createApp } from 'vue';
import PptxToJpgConverter from '@/Components/PptxToJpgConverter.vue';
import '@styles/app.css';

createApp(PptxToJpgConverter).mount('#pptx-to-jpg-converter');
